import styled from '@emotion/styled'
import { css } from '@emotion/react'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import DropdownButton from '@groovehq/internal-design-system/lib/components/Dropdown/DropdownButton'
import DropdownMenu from '@groovehq/internal-design-system/lib/components/Dropdown/DropdownMenu'

import { isEmpty } from 'util/arrays'

import Mailbox from './SelectedMailbox'

const mailboxStyle = () => theme => css`
  margin-left: ${theme.spacing['3']};
`

const MailboxDropdown = ({ onClick, mailbox, mailboxes }) => {
  if (isEmpty(mailboxes)) {
    return <Mailbox mailbox={mailbox} css={mailboxStyle} />
  }

  return (
    <Dropdown
      hasMinWidth
      strategy="fixed"
      portal="#overlays"
      onSelect={onClick}
      overlay={
        <DropdownMenu>
          {mailboxes.map(m => (
            <DropdownMenu.Item key={m.id} itemKey={m.id} item={m}>
              <Mailbox mailbox={m} />
            </DropdownMenu.Item>
          ))}
        </DropdownMenu>
      }
    >
      <DropdownButton size="small" textBtn css={mailboxStyle}>
        <Mailbox mailbox={mailbox} />
      </DropdownButton>
    </Dropdown>
  )
}

export default styled(MailboxDropdown)`
  &&& {
    align-items: center;
    color: ${props => props.theme.color.primary.brand};
    cursor: pointer;
    display: inline-flex;
    margin-left: ${props => props.theme.spacing['3']};

    .dropdown {
      &.icon {
        /* SUI override for a bigger caret thats closer to icon */
        font-size: ${props => props.theme.fontSize.small} !important;
        margin-left: ${props => props.theme.spacing['4']} !important;
      }
    }
  }
`
